import { render, staticRenderFns } from "./attachments-viewer.vue?vue&type=template&id=0a6ea888&scoped=true&"
import script from "./attachments-viewer.vue?vue&type=script&lang=js&"
export * from "./attachments-viewer.vue?vue&type=script&lang=js&"
import style0 from "./attachments-viewer.vue?vue&type=style&index=0&id=0a6ea888&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6ea888",
  null
  
)

export default component.exports